import { shopifyServiceBaseUrl } from "../../core/config";

const postForm = ({ endpoint, gatewayName = "", body = {} }) => {
  const form = document.createElement("form");
  form.action = `${shopifyServiceBaseUrl}${endpoint}/${gatewayName}`;
  form.method = "POST";
  form.style.display = "none";

  Object.keys(body).forEach((key) => {
    const elem = document.createElement("input");
    elem.name = key;
    elem.value = body[key];
    form.appendChild(elem);
  });

  document.body.appendChild(form);
  form.submit();
};

export default postForm;
